export default "__VITE_ASSET__BUoiDZr3__"